export class WeekViewUserModeUsersModel {
    constructor() {
        this.userName = "";
    }
}
export default class WeekViewUserModeUsers extends WeekViewUserModeUsersModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
